import { render } from "./deleteManagerView.vue?vue&type=template&id=8f894e4a&scoped=true&ts=true"
import script from "./deleteManagerView.vue?vue&type=script&lang=ts"
export * from "./deleteManagerView.vue?vue&type=script&lang=ts"

import "./deleteManagerView.vue?vue&type=style&index=0&id=8f894e4a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f894e4a"]])

export default __exports__